import { jsx as _jsx } from "react/jsx-runtime";
import { useHistory } from 'react-router';
import { useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { PracticeManagement } from '~/types/api.model';
import APIKeyModal from '../APIKeyModal/APIKeyModal';
import { CardHandler } from '../APIKeyPM/APIKeyPM.utils';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import KarbonLogo from './KarbonLogo';
const KarbonCard = (param)=>{
    let { integration } = param;
    const { t: texts } = useLocaleKeys('integrations.availableApps.karbon');
    const history = useHistory();
    const overlayContext = useOverlayContext();
    const { api, fetchIntegrations } = useStoreActions();
    const ui = {
        goToPage: (page)=>history.push(page),
        requestApiKey: (apiKeyListener)=>overlayContext.showModal({
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(APIKeyModal, {
                        pmName: PracticeManagement.Karbon,
                        dismissModal: dismissModal,
                        apiKeyListener: apiKeyListener
                    });
                }
            }),
        refetchIntegrations: async ()=>fetchIntegrations()
    };
    const server = {
        saveApiKey: async (apiKey)=>api.karbon.setAPIKey(apiKey)
    };
    const karbonCardHandler = new CardHandler(ui, integration, server);
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "karbon-card",
        title: texts.title(),
        subTitle: texts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            testId: "karbon-card-connect",
            onClick: ()=>karbonCardHandler.handleClick(routes.karbonSetup),
            children: karbonCardHandler.getActionText()
        }),
        icon: /*#__PURE__*/ _jsx(KarbonLogo, {})
    });
};
export default KarbonCard;
